import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {ClassificationMetadataResponse} from '../types'

export const MaterialsClassificationMetadataQueryKey = 'classificationMetadata'

const materialsClassificationMetadataQueryOptions = () => ({
  queryKey: [MaterialsClassificationMetadataQueryKey] as const,
  queryFn: async ({signal}: {signal?: AbortSignal}) => {
    const response = await ApiClient.axiosInstance.get<ClassificationMetadataResponse>(
      '/plants/materials/material-classification-metadata',
      {signal}
    )
    return response.data
  }
})

type Params<TReturn = ClassificationMetadataResponse> = {
  options?: Omit<
    UseQueryOptions<ClassificationMetadataResponse, AxiosError, TReturn>,
    'queryKey' | 'queryFn'
  >
}

export const useMaterialsClassificationMetadata = <TReturn = ClassificationMetadataResponse>({
  options
}: Params<TReturn> = {}) =>
  useQuery<ClassificationMetadataResponse, AxiosError, TReturn>({
    ...materialsClassificationMetadataQueryOptions(),
    ...options
  })
